import React from "react";
import PropTypes from "prop-types";

import Header from "./header";
import Footer from "./footer";

import "./css/index.scss";

const Layout = ({ children, email, role, pages }) => (
  <>
    <Header email={email} role={role} pages={pages} />
    <section className="main-container">
      <div className="container">{children}</div>
    </section>
    <Footer />
  </>
);

Layout.propTypes = {
  children: PropTypes.node,
  email: PropTypes.string,
  role: PropTypes.string,
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
      active: PropTypes.bool
    })
  )
};

Layout.defaultProps = {
  children: "",
  email: "",
  role: "",
  pages: [{ name: "Conciliaciones", path: "/", active: true }]
};

export default Layout;
